import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import {
  EXPLANATION,
  EXPLANATIONS,
  ExplanationsOptions,
  PLUGIN_EXPLANATON_PRESENT_TYPES,
} from './types';

import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import React from 'react';
import { RenderElementProps } from 'slate-react';
import { PARAGRAPH_TOGGLE } from '../ParagraphToggle/types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const ExplanationElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent<RenderElementProps>(() =>
    import(
      /* webpackExports: "ExplanationElementReadOnly" */ './components/readonly/ExplanationElement'
    ).then((mod) => mod.ExplanationElementReadOnly)
  )
);
const ExplanationsElement = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent<RenderElementProps>(() =>
    import('./components/readonly/ExplanationsElement').then(
      (mod) => mod.ExplanationsElementReadOnly
    )
  )
);
const ResultExplanation = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import('./components/readonly/ResultExplanation').then((mod) => mod.ResultExplanationReadOnly)
  )
);

const renderElementExplanations = (options?: any) => (props: RenderElementProps) => {
  const { element } = props;
  if (
    element.type === PARAGRAPH_TOGGLE &&
    element.present === PLUGIN_EXPLANATON_PRESENT_TYPES.EXPLANATION &&
    element.parentNodeType === EXPLANATIONS
  ) {
    return <ResultExplanation {...props} />;
  }

  switch (element.type) {
    case EXPLANATIONS:
      return <ExplanationsElement {...props} />;

    case EXPLANATION:
      return <ExplanationElementReadOnly {...props} />;
    default:
      return undefined;
  }
};

export const ExplanationsReadOnlyPlugin = (options?: ExplanationsOptions): SlatePlugin => ({
  renderElement: renderElementExplanations(options),
});
